// A valid email address:
// - a valid username and a valid domain separated by @
// A valid username:
// - Can contain letters (a-z, A-Z), numbers (0-9), and certain special characters: dot, dash, underscore, plus
// - Must start with a letter or number.
// - Cannot end with a period, and cannot have consecutive periods.
// - Can be up to 64 characters long
// A valid domain:
// - Each label in the domain name should consist of letters (a-z, A-Z), digits (0-9), or hyphens (-).
// - The first and last characters of each label should not be a hyphen
// - The total length of the domain name should not exceed 253 characters
// - The top-level domain (TLD) should be a valid TLD
export const isValidEmail = (email: string) => {
    const chunks = email.split('@')

    if (chunks.length !== 2 || !chunks[0] || !chunks[1]) {
        return false
    }

    const username = chunks[0]
    const usernameRegExp = /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+[_+]?)*$/
    const usernameIsValid =
        username.length <= 64 && usernameRegExp.test(username)

    if (!usernameIsValid) {
        return false
    }

    const domain = chunks[1]
    const domainChunks = domain.split('.')

    if (domainChunks.length < 2) {
        return false
    }

    const domainChunkRegExp = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/
    const domainIsValid =
        domain.length <= 253 &&
        domainChunks.every((chunk) => domainChunkRegExp.test(chunk))

    return domainIsValid
}
